const Button = (props) => {
  const { loading, disabled, color, block, textLoading, title, className, size, ...rest } = props
  return (
    <button
      disabled={loading ? "disabled" : disabled ? "disabled" : ""}
      className={`btn ${size && "btn-" + size} btn-${color} ${block && "btn-block"} ${className}`}
      {...rest}
    >
      {loading ? (
        <>
          <i className="fas fa-spinner fa-spin"></i> &nbsp; {textLoading}
        </>
      ) : (
        title
      )}
    </button>
  );
};

Button.defaultProps = {
  loading: false,
  disabled: false,
  type: "button",
  title: "",
  block: null,
  color: "primary",
  textLoading: "Loading...",
  className: "",
  size: ""
}

export default Button;